module.exports = __webpack_public_path__ + "img/Logo_Benz.a520d78e.svg";